import React from "react";
import PropTypes from "prop-types";
// Material imports
import Button from "@mui/material/Button";
// limitless imports
import ConversationPanelContainer from "../conversation-panel-container/ConversationPanelContainer";
const ConversationDetailedReviewPanelFooter = ({
  cancelEditingMessage,
  saveQualityReview,
  completeReviewDisabled
}) => {
  return /*#__PURE__*/React.createElement(ConversationPanelContainer, {
    rightSpacing: 12
  }, /*#__PURE__*/React.createElement(Button, {
    id: "cancelButton",
    variant: "contained",
    onClick: cancelEditingMessage,
    size: "small"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    id: "completeReviewButton",
    variant: "contained",
    disabled: completeReviewDisabled,
    onClick: saveQualityReview
  }, "Complete review"));
};
export default ConversationDetailedReviewPanelFooter;
ConversationDetailedReviewPanelFooter.propTypes = {
  cancelEditingMessage: PropTypes.func.isRequired,
  saveQualityReview: PropTypes.func.isRequired,
  completeReviewDisabled: PropTypes.bool.isRequired
};